import { Input,Component, ViewChild } from "@angular/core";
import { BasePageComponent } from '@base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { GridExtender } from "@base/grid/Grid.extender";

import { HistoryEventTypesEnum, EnumPageDisplayModes } from '@m4u-angular/core/framework/sysenums.enum';
import { HistoryViewGridComponent } from '@m4u-angular/ui/components/general/history-view/grid/historyview-grid.component'
import { BaseEntity, BaseState, HistoryChangeDetails, HistoryChangesSet } from '@base/entities/BaseEntities';
import dxScrollView from 'devextreme/ui/scroll_view';

class State extends BaseState {
    SearchUntilDate: Date;
    SearchFromDate: Date;

}

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-historyview',
    templateUrl: './historyview.component.html',
    styleUrls: ['./historyview.component.scss']
})

export class HistoryViewComponent extends BasePageComponent<BaseEntity, State> { 

    @Input() Entities: HistoryChangesSet[];

    constructor(A: ServiceBagService) {
        super(A, 'HistoryViewComponent', BaseEntity, State, EnumPageDisplayModes.Dialog);
    }

    protected override OnInitComponentFinished(): void {
        setTimeout(() => {
            const scroll = dxScrollView.getInstance(document.querySelector('.history-view-page .page-body')) as any;
            scroll && scroll.scrollTo({ top: scroll.scrollHeight() });
        });
    }

    IsShowDate(item: HistoryChangesSet) {
        const itemIndex = this.Entities.indexOf(item);
        return itemIndex === 0 || this.Entities[itemIndex - 1].CreatedDate.ToDate().getTime() != item.CreatedDate.ToDate().getTime();
    }

    GetEntityChangesContext(item: HistoryChangesSet) {
        return { items: item.HistoryChanges, type: 'entity', getChangeLabel: (item: HistoryChangeDetails) => this.GetEntityChangeLabel(item) };
    }

    private GetEntityChangeLabel(item: HistoryChangeDetails) {
        const entityName = item.Name && item.EntityType !== item.Name ? item.Name : '';
        switch (item.Action) {
            case HistoryEventTypesEnum.RowAdded:
                return this.RC('lblHistoryChangeAdded', item.EntityType, entityName);
            case HistoryEventTypesEnum.RowDeleted:
                return this.RC('lblHistoryChangeRemoved', item.EntityType, entityName);
            case HistoryEventTypesEnum.FieldChange:
            case HistoryEventTypesEnum.Special:
                return `${item.EntityType} ${entityName}`;
        }
    }

    GetLineChangesContext(item: HistoryChangesSet) {
        return { items: item.HistoryLineChanges, type: 'lines', getChangeLabel: (item: HistoryChangeDetails) => this.GetLineChangeLabel(item) };
    }

    GetLineChangeLabel(item: HistoryChangeDetails) {
        switch (item.Action) {
            case HistoryEventTypesEnum.RowAdded:
                return this.RC('lblHistoryLineAdded', item.EntityType, `${item.EntityLineID + 1}`);
            case HistoryEventTypesEnum.RowDeleted:
                return this.RC('lblHistoryLineRemoved', item.EntityType, `${item.EntityLineID + 1}`);
            case HistoryEventTypesEnum.FieldChange:
                return `${item.EntityType} ${item.EntityLineID + 1}`;
        }
    }

    ShowChangeLabel(items: HistoryChangeDetails[], item: HistoryChangeDetails, index: number, type: 'entity' | 'lines') {
        return (item.Action !== 'Special') && index > 0 
            ? type === 'entity' 
                ? items[index].EntityEntryID !== items[index - 1].EntityEntryID || items[index].Action !== items[index - 1].Action
                : items[index].EntityLineID !== items[index - 1].EntityLineID || items[index].Action !== items[index - 1].Action
            : true;
    }

    IsItemCollapsed(item) {
        return this.Entities.indexOf(item) !== this.Entities.length - 1;
    }
}
